<template>
  <UiModal
    :show="showAmount"
    size="lg"
    title="贡献奖励"
    iconType="gift_2"
    @close="close"
  >
    <div class="bonus">
      <div class="bg"></div>
    </div>
  </UiModal>
</template>

<script setup>
import { ref } from 'vue'
import { useModal } from '@/composables/useModal'
import UiModal from "@/components/ui-modal.vue";

const showAmount = ref(false)
const { close } = useModal('personal-rewards', showAmount)
</script>

<style lang="scss" scoped>
.bonus{
  width: 100%;
  height: 100%;
  .bg{
    width: 100%;
    height: 100%;
    background: url(https://website.xdcdn.net/poster/58881/26match/common/QfXZlk9d.png) center/contain no-repeat;
  }
}
</style>
